module.exports = __webpack_public_path__ + "img/loader.d113ace4.gif";